export default __webpack_public_path__ + "03ff190c01c9c32e6fb670d35fbe948c.png";